import { render, staticRenderFns } from "./ExchangePassports.vue?vue&type=template&id=f1ee0f5a"
import script from "./ExchangePassports.vue?vue&type=script&lang=js"
export * from "./ExchangePassports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports